<template>
  <v-card :loading="loading">
    <v-card-title>
      Custom Options
      <v-spacer></v-spacer>
      <v-btn :loading="loading" fab small color="primary" @click="toggleForm">
        <v-icon>{{ showForm ? 'mdi-close' : 'mdi-plus' }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <template>
        <v-scroll-x-transition>
          <v-btn :loading="loading" v-if="isAdmin && selected.length" dark color="red" @click="deleteConfig">
            <v-icon left>mdi-delete</v-icon>
            {{ deleteLabel }}
          </v-btn>
        </v-scroll-x-transition>
      </template>

      <template v-if="showForm">
        <v-form v-model="form.valid">
          <v-text-field
            v-bind="inputProps"
            :label="`Custom Option`"
            v-model="form.name"
            :rules="[rules.required]"
          ></v-text-field>

          <v-btn :loading="loading" class="mt-4" color="green" dark @click="save"> save </v-btn>
        </v-form>
      </template>
      <template>
        <v-data-table fixed-header :headers="headers" :items="rows" :show-select="showSelect" v-model="selected">
        </v-data-table>
      </template>
    </v-card-text>
  </v-card>
</template>
<script>
import { inputProps, pluralize } from '@/util';
import { required } from '@/util/rules';
import { mapActions, mapGetters } from 'vuex';

const DEFAULT_FORM = {
  name: null,
  valid: false,
};
const CONFIG_LIMIT = 3;

export default {
  name: 'DropOffPickup',
  props: {
    type: { type: String, required: true },
  },
  data() {
    return {
      showForm: false,
      inputProps,
      rules: {
        required,
      },
      form: { ...DEFAULT_FORM },
      config: [],
      selected: [],
      loading: false,
      CONFIG_LIMIT,
    };
  },
  computed: {
    ...mapGetters('config', ['tripRequestConfig', 'transportationCustomOptions']),
    ...mapGetters('user', ['isAdmin']),
    deleteLabel() {
      const count = this.selected.length;
      return `Delete ${count} ${pluralize('Custom Option', count)}`;
    },
    showSelect() {
      return this.isAdmin;
    },
    headers() {
      return [{ text: 'Custom Option', value: 'name' }];
    },
    rows() {
      return this.transportationCustomOptions;
    },
  },
  methods: {
    ...mapActions('config', {
      getConfig: 'getConfig',
      saveConfig: 'setConfig',
      saveTransportationCustomOption: 'saveTransportationCustomOption',
      deleteTransportationOptionsByIds: 'deleteTransportationOptionsByIds',
    }),
    async deleteConfig() {
      this.loading = true;
      try {
        const selectedIds = this.selected.map((items) => items.id);
        await this.deleteTransportationOptionsByIds(selectedIds);

        this.selected = [];
      } catch (e) {
        this.$myalert.error(e.message, true);
      } finally {
        await this.fetchConfig();
        this.setConfig();

        this.loading = false;
      }
    },
    async save() {
      this.loading = true;
      try {
        if (this.config.length >= CONFIG_LIMIT)
          throw new Error(`You can only have op to ${CONFIG_LIMIT} custom options`);

        await this.saveTransportationCustomOption(this.form.name);

        this.toggleForm();
      } catch (e) {
        this.$myalert.error(e.message, true);
      } finally {
        await this.fetchConfig();
        this.setConfig();

        this.loading = false;
      }
    },
    resetForm() {
      this.form = { ...DEFAULT_FORM };
    },
    toggleForm() {
      this.resetForm();
      this.showForm = !this.showForm;
    },
    async setConfig() {
      this.config = this.tripRequestConfig?.display?.transportationCustomOptions || [];
    },
    async fetchConfig() {
      await this.getConfig('tripRequestForm');
    },
  },
  async mounted() {
    await this.fetchConfig();
    this.setConfig();
  },
};
</script>
